import React, { useContext, useEffect, useState } from "react";
import {
  AppContext,
  MAIN_MENU_ALL_SET,
  SELFCAED_MENU_ALL_SET,
  SET_APP_ALL,
  SET_MENU_NEW_REPORT_LIST,
  SET_SUBMIT_DATA_SIZE,
  SocketCommand,
  socketManager,
} from "./AppProvider";

import { LOG_IN_SUCCESS } from "./AppProvider";

// Utils

// Assets

import { PostApi1913, PostApiAppStdInfo, PostApiGetNewPoint } from "../modules/network/padoPost";
import {
  getCookie,
  getCookieWs,
  getCookies,
  setCookies,
} from "../modules/utils/cookie";
import { resEvent } from "../views/Nftf/Interface/NFTF/NativeApi";

const UserInfoGenerator = ({ children }) => {
  const { phonecfg, auth, userinfo, dispatch, cfg, deviceCfg } =
    useContext(AppContext);

  const [isLoading, setIsLoading] = useState(true);

  const reLogin = () => {
    const main = getCookie("main");
    main && dispatch({ type: MAIN_MENU_ALL_SET, data: main }); // main
    const selfcard = getCookie("selfcard");
    selfcard && dispatch({ type: SELFCAED_MENU_ALL_SET, data: selfcard }); // selfcard
  };

  const request1913 = userinfo => {
    PostApi1913(userinfo, cfg, phonecfg).then(res => {
      if (res.resultMsg === "SUCCESS") {
        let data = res.result;
        dispatch({ type: SET_APP_ALL, data: data });
      } else {
        console.log("LOGOUT!!!");
      }
    });
  };

  const requestGetNewPoint = userinfo => {
    PostApiGetNewPoint(userinfo, cfg, phonecfg)
      .then(res => {
        if (res.resultCode === "E000") {
          dispatch({ type: SET_MENU_NEW_REPORT_LIST, data: res.result });
        } else {
          console.log("Interface Fail");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const getLoginInfoRes = data => {
    let jsonData = JSON.parse(data.cookieData);

    if (data.isResult === 200) {
      setCookies(jsonData.loginInfo);
    }

    if (phonecfg.version === "2.0.0") {
      if (phonecfg.phoneOS == "IOS") {
        socketManager(SocketCommand.GET_PHONE_INFO, undefined);
      } else {
        // 임시방편
        socketManager(SocketCommand.GET_PHONE_INFO_OLD, undefined);
      }
    }

    if (getCookie("isAutologin")) {
      const userInfo = getCookies([
        "userToken",
        "userName",
        "userEmail",
        "userPhone",
        "sex",
        "birth",
      ]);

      if (userInfo.userToken) {
        dispatch({ type: LOG_IN_SUCCESS, data: userInfo });
        request1913(userInfo);
        reLogin();
        requestGetNewPoint(userInfo);
      }
    }

    setMinMax(dispatch, cfg);
    setIsLoading(false);
  };

  const getCookieWsTest = () => {
    if (phonecfg.version === "2.0.0") {
      if (phonecfg.phoneOS == "IOS") {
        socketManager(SocketCommand.GET_PHONE_INFO, undefined);
      } else {
        // 임시방편
        socketManager(SocketCommand.GET_PHONE_INFO_OLD, undefined);
      }
    }

    if (getCookie("isAutologin")) {
      const userInfo = getCookies([
        "userToken",
        "userName",
        "userEmail",
        "userPhone",
        "sex",
        "birth",
      ]);

      if (userInfo.userToken) {
        dispatch({ type: LOG_IN_SUCCESS, data: userInfo });
        request1913(userInfo);
        reLogin();
        requestGetNewPoint(userInfo);
      }
    }

    setMinMax(dispatch, cfg);
    setIsLoading(false);
  };

  useEffect(() => {
    getCookieWs(getLoginInfoRes);

    if (getCookie("isAutologin")) {
      const userInfo = getCookies([
        "userToken",
        "userName",
        "userEmail",
        "userPhone",
        "sex",
        "birth",
      ]);

      if (userInfo.userToken) {
        dispatch({ type: LOG_IN_SUCCESS, data: userInfo });
        request1913(userInfo);
        reLogin();
        requestGetNewPoint(userInfo);
      }
    }

    setMinMax(dispatch, cfg);
    setIsLoading(false);
  }, []);

  useEffect(() => {
    window.NativeInterface = {
      nativeResponse: value => {
        resEvent(value, dispatch, deviceCfg);
      },
    };
  }, []);

  return <>{isLoading ? "loading_V" : children}</>;
  // return <>{isLoading ? <Loading /> : children}</>;
};

const setMinMax = (dispatch, cfg) => {
  let result;

  PostApiAppStdInfo(cfg)
    .then((res) => {
      if (res.resultMsg === "SUCC") {
        result = res.appStdInfo;
        dispatch({ type: SET_SUBMIT_DATA_SIZE, data: res.appStdInfo });
      }
    })
    .catch((err) => {
      console.log("ERR :: ", err);
    });
  return result;
};

export default UserInfoGenerator;
